import React from "react";
import { Link } from "react-router-dom";
import Logo from "@/components/Logo";
import { Plus, ShieldCheck } from "lucide-react";

/** Reusable two-column auth layout */
export default function AuthLayout({ title, subtitle, children, footer }) {
  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-white">
      {/* Left panel - brand / illustration */}
      <div className="hidden lg:flex flex-col justify-between bg-gradient-to-br from-blue-600 via-blue-700 to-indigo-700 text-white p-10 relative overflow-hidden">
        <div className="absolute inset-0 grain opacity-20" />
        {[...Array(6)].map((_, i) => (
          <Plus
            key={i}
            className="float-plus text-white/15 absolute"
            style={{
              top: `${10 + (i * 14) % 80}%`,
              left: `${(i * 23) % 90}%`,
              width: 18 + (i % 3) * 6,
              height: 18 + (i % 3) * 6,
              animationDelay: `${i * 0.5}s`,
            }}
          />
        ))}

        <Link to="/" className="relative z-10 inline-block bg-white/10 backdrop-blur rounded-2xl p-3 w-fit">
          <Logo />
        </Link>

        <div className="relative z-10">
          <h2 className="font-heading text-4xl xl:text-5xl font-extrabold leading-tight">
            Crack NEET PG with confidence.
          </h2>
          <p className="mt-3 text-blue-50/90 text-lg max-w-md">
            Join 50,000+ aspirants using DearDr&apos;s AI-powered question bank, mock tests and analytics.
          </p>

          <div className="mt-8 grid grid-cols-3 gap-4 max-w-md">
            {[
              { k: "20,000+", v: "MCQs" },
              { k: "800+", v: "Exams" },
              { k: "10 yrs", v: "Q-Bank" },
            ].map((s) => (
              <div key={s.v} className="bg-white/10 backdrop-blur rounded-xl p-3 text-center">
                <div className="font-heading text-xl font-extrabold">{s.k}</div>
                <div className="text-[11px] uppercase tracking-[0.15em] opacity-90">{s.v}</div>
              </div>
            ))}
          </div>
        </div>

        <div className="relative z-10 flex items-center gap-2 text-sm opacity-90">
          <ShieldCheck className="h-4 w-4" />
          Your data is encrypted and secure.
        </div>
      </div>

      {/* Right panel - form */}
      <div className="flex items-center justify-center p-6 sm:p-10">
        <div className="w-full max-w-md">
          <Link to="/" className="lg:hidden mb-6 inline-block">
            <Logo />
          </Link>
          <h1 className="font-heading text-3xl sm:text-4xl font-extrabold tracking-tight text-slate-900">
            {title}
          </h1>
          {subtitle && <p className="text-slate-600 mt-2">{subtitle}</p>}

          <div className="mt-7">{children}</div>

          {footer && <div className="mt-6 text-sm text-slate-600">{footer}</div>}
        </div>
      </div>
    </div>
  );
}
